<template>
  <modal title="Social Accounts" size="md" body-style="padding: 0" ref="modal">
    <accounts-list
      :client-id="clientId"
      :platforms="platforms"
      v-model:accounts="accounts"
      v-model:platform="platform"
      class="bg-grey-2"
      @update:platforms="setPlatforms"
    />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { Account, Platform } from '@/social/types';
import AccountsList from './list/AccountsList.vue';

interface Data {
  platforms: Platform[],
  accounts: Account[],
  platform: Platform|null
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
    AccountsList,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      platforms: [],
      accounts: [],
      platform: null,
    };
  },
  methods: {
    setPlatforms(platforms: Platform[]): void {
      this.platforms = platforms;
      if (platforms.length > 0) {
        [this.platform] = platforms;
      }
    },
  },
});
</script>
